// extracted by mini-css-extract-plugin
export default {"background":"appointment_background__IYV+2","heading":"appointment_heading__Vmba8","form":"appointment_form__HQy8n"};